import { FC } from 'react';

interface AvatarProps {
  src?: string;
  alt?: string;
  text?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl';
}

export const Avatar: FC<AvatarProps> = ({ size = 'md', src, alt, text }) => {
  // Get the first letter from name or email
  const getInitial = () => {
    if (text) {
      return text.charAt(0).toUpperCase();
    }
    return '?';
  };

  // Size mapping
  const sizeClasses = {
    sm: 'w-8 h-8 text-sm',
    md: 'w-10 h-10 text-base',
    lg: 'w-12 h-12 text-lg',
    xl: 'w-16 h-16 text-xl',
    '2xl': 'w-20 h-20 text-2xl',
    '3xl': 'w-24 h-24 text-3xl',
  };

  // If we have an image source, show the image
  if (src) {
    return (
      <img
        src={src}
        alt={alt || text || 'Avatar'}
        className={`${sizeClasses[size]} rounded-full object-cover`}
      />
    );
  }

  // Otherwise, show the initial in a green circle
  return (
    <div
      className={`${sizeClasses[size]} rounded-full bg-green-500 flex items-center justify-center text-white font-semibold`}
      title={text || 'Avatar'}>
      {getInitial()}
    </div>
  );
};
